<template>
  <div class="page-container">
    <div class="page-login">
      <div class="section-login">
        <div class="section-header">
          <div class="title">
            เข้าสู่ระบบจัดการข้อมูล
            <br />เว็บไซต์ ALTV
          </div>
        </div>
        <form @submit.prevent="login">
          <div class="invalid-text" v-if="loginState.error">
            <i class="fa fa-times" /> {{loginState.error}}
          </div>
          <div class="form-login-container">
            <FormGroup>
              <h5 class="name">อีเมล</h5>
              <input
                type="email"
                placeholder="อีเมล"
                class="form-control form-control-lg"
                :class="{'is-invalid': error.username}"
                @blur="validateUsername"
                v-model="account.username"/>
              <div
                class="invalid-feedback"
                v-if="error.username">
                {{error.username}}
              </div>
            </FormGroup>
          </div>
          <div class="form-login-container">
            <FormGroup>
              <h5 class="name">รหัสผ่าน</h5>
              <input
                type="password"
                placeholder="รหัสผ่าน"
                class="form-control form-control-lg"
                :class="{'is-invalid': error.password}"
                @blur="validatePassword"
                v-model="account.password" />
                <div
                  class="invalid-feedback"
                  v-if="error.password">
                  {{error.password}}
              </div>
            </FormGroup>
          </div>
          <div class="form-button">
            <button type="submit" class="btn btn-block btn-primary btn-lg" :disabled="!canLogin">
              <span>เข้าสู่ระบบ</span>
            </button>
          </div>
        </form>
      </div>
    </div>
    <div class="page-sidebar">
      <div class="logo">
        <img src="@/assets/images/altv-logo-light.png" />
      </div>
      <div class="branding">
        <h1 class="title">ช่อง 4 ทีวีเรียนสนุก</h1>
        <div class="subtitle">พื้นที่การเรียนรู้สำหรับทุกคน</div>
      </div>
    </div>
    <div class="page-border">
      <div class="page-border-item" v-for="item in 4" :key="item" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import FormGroup from '@/components/FormGroup.vue';
import { login } from './api';

export default {
  components: {
    FormGroup,
  },
  data() {
    return {
      loginState: {
        error: null,
      },
      account: {
        username: '',
        password: '',
      },
      error: {
        username: null,
        password: null,
      },
    };
  },
  created() {
    // Check that user already login or not?
    this.loadCurrentUser();
  },
  computed: {
    ...mapGetters(['currentUser']),
    canLogin() {
      if (this.error.username || this.error.password) {
        return false;
      }
      return true;
    },
    username() {
      return this.account.username;
    },
    password() {
      return this.account.password;
    },
  },
  watch: {
    // currentUser() {
    //   if (this.currentUser) this.$router.push('/');
    // },
    username() {
      this.validateUsername();
    },
    password() {
      this.validatePassword();
    },
  },
  methods: {
    async loadCurrentUser() {
      await this.$store.dispatch('loadCurrentUser');
      if (this.currentUser) {
        this.$router.push('/');
      }
    },
    async login() {
      try {
        await login(this.account);
        this.$router.push('/');
      } catch (error) {
        if (error.response.status === 401) {
          this.loginState.error = 'อีเมลหรือรหัสผ่านไม่ถูกต้อง';
        } else if (error.response.status === 403) {
          this.loginState.error = 'ผู้ใช้นี้ถูกระงับการใช้งาน';
        }
      }
    },
    validateUsername() {
      this.error.username = null;
      if (!this.account.username) {
        this.error.username = 'โปรดระบุอีเมล';
      }
    },
    validatePassword() {
      this.error.password = null;
      if (!this.account.password) {
        this.error.password = 'โปรดระบุรหัสผ่าน';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/app.scss';
@import './src/assets/scss/variables.scss';
@import './src/assets/scss/themes/components/section-container.scss';


.page-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #fdfdfd;

  display: flex;

  .invalid-text {
    color: #dc3545;
    text-align: center;
  }
  .page-sidebar {
    margin-left: auto;
    flex: 0 0 60%;
    background-color: $altv-navy;

    display: flex;
    flex-direction: column;

    align-items: center;
    justify-content: center;

    .branding {
      margin-top: $spacer * 2;
      color: $gray-100;

      .title {
        font-family: $font-family-DBHeavent;
        line-height: 0.6;
        font-size: $font-size-base * 4;
      }

      .subtitle {
        font-family: $font-family-DBHeavent;
        font-size: $font-size-base * 2.5;
      }
    }

    .logo {
      padding-top: calc(15% - 100px);
      padding-left: calc(10% - 100px);
      img {
        max-width: 400px;
      }
    }
  }

  .page-login {
    flex: 1 0 auto;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .section-login {
      padding-top: calc(20% - 45px);
      width: 50%;
      min-width: 400px;

      .section-header {
        margin-bottom: $spacer * 2;

        .title {
          font-size: $font-size-base * 4;
          color: $gray-900;
          font-family: $font-family-DBHeavent;
          font-weight: bold;
          line-height: 1;
        }
      }

      .form-login-container {
        margin-bottom: $spacer * 1.5;

        .name {
          color: $gray-800;
          font-family: $font-family-DBHeavent;
          font-size: $font-size-base * 2;
          line-height: 0.7;
        }

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
}

.page-border {
  position: fixed;

  bottom: 0;
  left: 0;
  right: 0;

  display: flex;

  .page-border-item {
    height: 10px;
    flex: 1;

    &:nth-child(1) {
      background-color: $altv-red;
    }

    &:nth-child(2) {
      background-color: $altv-mint;
    }

    &:nth-child(3) {
      background-color: $altv-pink;
    }

    &:nth-child(4) {
      background-color: $altv-blue;
    }
  }
}

@media (max-width: 767.98px) {
  .page-container {
    .page-sidebar {
      display: none;
    }

    .page-login {
      padding-left: $spacer;
      padding-right: $spacer;

      .section-login {
        padding-top: 40vh;
        width: 80vw;
        max-width: 400px;
        min-width: unset;

        .section-header {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          background-color: $altv-navy;
          height: 40vh;

          display: flex;
          align-items: flex-end;
          justify-content: center;

          padding-left: $spacer;
          padding-right: $spacer;

          .title {
            width: 80vw;
            max-width: 400px;
            color: white;
            padding-bottom: $spacer;
            font-size: 12vw;
          }
        }
      }
    }
  }
}

@media (min-width: 768px) and (max-width: 991.98px) {
  .page-container {
    .page-sidebar {
      display: none;
    }

    .page-login {
      padding-left: $spacer;
      padding-right: $spacer;

      .section-login {
        padding-top: 30vh;
        width: 80vw;
        max-width: 400px;
        min-width: unset;

        .section-header {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          background-color: $altv-navy;
          height: 35vh;

          display: flex;
          align-items: flex-end;
          justify-content: center;

          padding-left: $spacer;
          padding-right: $spacer;

          .title {
            width: 80vw;
            max-width: 400px;
            color: white;
            padding-bottom: $spacer;
            font-size: 12vw;
          }
        }
      }
    }
  }
}

@media (min-width: 992px) and (max-width: 1199.98px) {
  .page-container {

    .page-sidebar {
      flex: 0 0 50%;
    }

    .page-login {
      flex: 1 0 auto;

      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .section-login {
        padding-top: calc(20% - 45px);
        width: 50%;
        min-width: 400px;

        .section-header {
          margin-bottom: $spacer * 2;

          .title {
            font-size: $font-size-base * 4;
            color: $gray-900;
            font-family: $font-family-DBHeavent;
            font-weight: bold;
            line-height: 1;
          }
        }

        .form-login-container {
          margin-bottom: $spacer * 1.5;

          .name {
            color: $gray-800;
            font-family: $font-family-DBHeavent;
            font-size: $font-size-base * 2;
            line-height: 0.7;
          }

          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }
  }
}
</style>
